// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cgnyv","content":"styles_content__3zn3h","row":"styles_row__2bMfB","footer":"styles_footer__2H-FT","phraseLength":"styles_phraseLength__2y4pU"};